import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectFilterUserSelected = createSelector(
    [
        (store: RootState) => store.formSubmittedSlice.selectedUsers,
        (store: RootState) => store.formSubmittedSlice.searchSelectedUserText,
    ],
    (selectedUsers, selectedSearchText) => {
        const data = selectedUsers.filter(
            ({ user }) => {
                // Filtro por nombre 
                if (
                    selectedSearchText
                    && !user.name.toLowerCase().includes(selectedSearchText?.toLowerCase().trim())
                ) {
                    return false;
                }
                return true;
            }
        );
        // Ordena la lista alfabéticamente
        const orderedList = [...data].sort((a, b) => {
            if (a.user.name && b.user.name && a.user.name < b.user.name) {
                return -1;
            }
            if (a.user.name && b.user.name && a.user.name > b.user.name) {
                return 1;
            }
            return 0;
        });

        return orderedList;
    }
);
